import { AccountClosureFormValues } from '../../types';

const getFormDefaultValues = (): AccountClosureFormValues => ({
  hasLeftForCompetition: null,
  hasLeftForCompetitionExplanation: '',
  otherExplanation: '',
  reasons: new Set(),
  satisfiedMissingBankingServiceExplanation: '',
  satisfiedMissingFeatureExplanation: '',
  satisfiedNoActivityOrTooFewActivityForNowExplanation: '',
  satisfiedOtherExplanation: '',
  satisfiedPricingIssueExplanation: '',
  satisfiedTechnicalIssueExplanation: '',
  unsatisfiedBadBankingServiceExperienceExplanation: '',
  unsatisfiedBadSupportExperienceExplanation: '',
  unsatisfiedMissingBankingServiceExplanation: '',
  unsatisfiedMissingFeatureExplanation: '',
  unsatisfiedOtherExplanation: '',
  unsatisfiedPricingIssueExplanation: '',
  unsatisfiedTechnicalIssueExplanation: '',
});

export default getFormDefaultValues;
